import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message, FormInstance } from "antd";
import GenericModal from "../../modal";
import AddDeviceForm from "./addDeviceModal";
import { useAddUserPermisionMutation } from "../../../services/device";
import { showError } from "../../../ultils/helpers";

// Giả sử bạn có một component ResetPasswordForm
import ResetPasswordForm from "./changePasswordModal";
import { useChangePasswordMutation } from "../../../services/auth";
import { User } from "../../../types/user";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface UserFormProps {
  initialValues: User;
  onSubmit: (values: User) => void;
  form: FormInstance<any>;
}

const UserForm: React.FC<UserFormProps> = ({
  initialValues,
  onSubmit,
  form,
}) => {
  const [
    addUserPermision,
    { data: addPermisionData, error: addPermisionError },
  ] = useAddUserPermisionMutation();

  const [
    changePassword,
    { data: changePasswordData, error: changePasswordError },
  ] = useChangePasswordMutation();
  const [formAddDevicePermision] = Form.useForm();
  const [formChangePassword] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [isModalVisible, setIsModalVisible] = useState(false);
  // Thêm state cho modal đặt lại mật khẩu
  const [isResetPasswordModalVisible, setIsResetPasswordModalVisible] =
    useState(false);

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  // Hàm mở và đóng modal đặt lại mật khẩu
  const openResetPasswordModal = () => {
    setIsResetPasswordModalVisible(true);
  };

  const closeResetPasswordModal = () => {
    setIsResetPasswordModalVisible(false);
  };

  const handleSubmitAddDevice = async () => {
    formAddDevicePermision
      .validateFields()
      .then(async (values) => {
        await addUserPermision({
          device_id: values.hardware_id,
          user_permissions: values.user_permissions,
          user_id: initialValues._id,
        });
        closeModal();
      })
      .catch((errorInfo) => {
      });
  };

  const handleSubmitChangePassword = async () => {
    formChangePassword
      .validateFields()
      .then(async (values) => {
        await changePassword({
          userId: initialValues._id,
          newPassword: values.newPassword,
          userRole: 3,
        });
        closeResetPasswordModal();
      })
      .catch((errorInfo) => {
      });
  };

  useEffect(() => {
    if (addPermisionData) {
      messageApi.success("Thêm thiết bị cho người dùng thành công");
    }
    if (changePasswordData) {
      messageApi.success("Thay đổi password thành công");
    }
  }, [addPermisionData, changePasswordData, messageApi]);

  useEffect(() => {
    if (addPermisionError) {
      message.error("Test");
      showError(addPermisionError, messageApi);
    }
  }, [addPermisionError]);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  return (
    <>
      {contextHolder}
      <Form
        form={form}
        initialValues={initialValues}
        onFinish={onSubmit}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          name="user_name"
          label="Tên người dùng"
          rules={[
            {
              required: true,
              message: "Vui lòng không để trống tên người dùng",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập email!",
            },
            {
              type: "email",
              message: "Email không hợp lệ!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        {initialValues ? null : (
          <Form.Item
            name="password_hash"
            label="Mật khẩu"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống mật khẩu",
              },
              { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự!" },
            ]}
          >
            <Input />
          </Form.Item>
        )}

        {/* Modal thêm thiết bị */}
        <GenericModal
          width={550}
          visible={isModalVisible}
          onClose={closeModal}
          title={"Thêm thiết bị cho người dùng"}
          content={
            <AddDeviceForm
              form={formAddDevicePermision}
              userId={initialValues?._id}
            />
          }
          footer={
            <Button type="primary" onClick={handleSubmitAddDevice}>
              Lưu
            </Button>
          }
        />

        {/* Modal đặt lại mật khẩu */}
        <GenericModal
          width={550}
          visible={isResetPasswordModalVisible}
          onClose={closeResetPasswordModal}
          title={"Đặt lại mật khẩu"}
          content={<ResetPasswordForm form={formChangePassword} />}
          footer={
            <Button type="primary" onClick={handleSubmitChangePassword}>
              Lưu
            </Button>
          }
        />

        <Form.Item label={null}>
          <Button style={{ width: "120px" }} type="primary" htmlType="submit">
            Lưu
          </Button>
        </Form.Item>
        {initialValues ? (
          <div style={{ marginTop: "40px" }}>
            <Row gutter={[16, 16]}>
              {initialValues && initialValues.role === 1 ? (
                <Col span={6}>
                  <Button onClick={openModal}>Thêm thiết bị</Button>
                </Col>
              ) : (
                <></>
              )}

              <Col span={4}>
                {/* Gắn sự kiện onClick để mở modal */}
                <Button onClick={openResetPasswordModal}>
                  Đặt lại mật khẩu
                </Button>
              </Col>
            </Row>
          </div>
        ) : null}
      </Form>
    </>
  );
};

export default UserForm;
